module.exports = __webpack_public_path__ + "img/no-picture-new.00bffa9b.jpg";